import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { alertError, alertInfo } from "actions/ui";
import { sendAuth, clearAuth } from "actions/auth";
import { refreshAuthenticationData } from "actions/application";

class AuthExternal extends React.Component {

	get AUTH_MODE() {
		return 'anonymous';
	}

	constructor(props) {
		super(props);

		this.handleAnonymousAuth = this.handleAnonymousAuth.bind(this);
	}

	componentDidUpdate(prevProps) {
		const authSuccess = this.props.authResult !== prevProps.authResult && this.props.authResult && this.props.authResult.success === true;
		const authFailure = this.props.authResult !== prevProps.authResult && this.props.authResult && this.props.authResult.success === false;

		if (authFailure) {
			this.props.alertError(this.props.authResult.error);
			this.props.clearAuth(this.AUTH_MODE);
		}
		if (authSuccess) {
			this.props.refreshAuthenticationData();
			this.props.clearAuth(this.AUTH_MODE);
		}
	}

	handleAnonymousAuth() {
		this.props.sendAuth(this.AUTH_MODE, {
			nonce: this.props.auth.anonymous.nonce
		});
	}

	render() {
		return(
			<div className="wcAuthForm wcAuthExternal">
				{this.props.auth.anonymous &&
					<React.Fragment>
						<button className="wcButton wcAnonymousLoginButton" type="button" onClick={ this.handleAnonymousAuth }>{ this.props.configuration.i18n.logInAnonymously }</button>
						<div className="wcHint">{ this.props.configuration.i18n.logInUsing }</div>
					</React.Fragment>
				}

				<div className="wcFormRow">
					{this.props.auth.facebook &&
						<a href={ this.props.auth.facebook.url } className="wcFacebookLoginButton" title="Facebook sign in">Facebook</a>
					}
					{this.props.auth.twitter &&
						<a href={ this.props.auth.twitter.url } className="wcTwitterLoginButton" title="Twitter sign in">Twitter</a>
					}
					{this.props.auth.google &&
						<a href={ this.props.auth.google.url } className="wcGoogleLoginButton" title="Google sign in">Google</a>
					}
				</div>

				{ this.props.configuration.interface.auth.error &&
					<div className="wcErrorBox wcAuthExternalError">
						{ this.props.configuration.interface.auth.error }
					</div>
				}
			</div>
		)
	}

}

AuthExternal.propTypes = {
	configuration: PropTypes.object.isRequired,
	auth: PropTypes.object.isRequired,
};

export default connect(
	(state) => ({
		configuration: state.configuration,
		auth: state.application.auth,
		authResult: state.auth.sent['anonymous']
	}),
	{ alertError, alertInfo, sendAuth, clearAuth, refreshAuthenticationData }
)(AuthExternal);